import { createSelector } from 'reselect';

export const selectRelatedStores = state => state.relatedStores;

export const selectRelatedStoresByNamespace = createSelector(
  [
    state => state.relatedStores,
    (state, namespace = 'default') => namespace,
  ],
  (relatedStores, namespace) => {
    const { defaults = {} } = relatedStores;
    return relatedStores[`namespace-${namespace}`] || defaults;
  },
);

export const selectRelatedStoresConfig = createSelector(
  selectRelatedStores,
  relatedStores => relatedStores.config,
);

export const makeSelectRelatedStoresMerchants = () => (
  createSelector(
    selectRelatedStoresByNamespace,
    ({ merchants }) => merchants,
  )
);

export const makeSelectRelatedStoresIsLoading = () => (
  createSelector(
    selectRelatedStoresByNamespace,
    ({ isLoading }) => isLoading,
  )
);

export const makeSelectRelatedStoresIsLoaded = () => (
  createSelector(
    selectRelatedStoresByNamespace,
    ({ isLoaded }) => isLoaded,
  )
);

export const selectAllRelatedStoresMerchants = createSelector(
  selectRelatedStores, (relatedStores) => (
    Object.entries(relatedStores).reduce((result, [key, value]) => {
      if (!key.includes('namespace-')) {
        return result;
      }

      // filter out possible duplicates
      const uniqMerchants = value.merchants.filter(({ id }) => result.every((item) => id !== item.id));

      return [...result, ...uniqMerchants];
    }, [])
  ),
);

export const selectAllMerchantsAreLoaded = createSelector(
  selectRelatedStores,
  (relatedStores) => {
    const isLoadedStatuses = Object.entries(relatedStores)
      .filter(([key]) => key.includes('namespace-'))
      .map(([, value]) => value.isLoaded);
    // The additional 'length' check is made because the Array.every returns 'true' for empty arrays
    return isLoadedStatuses.length && isLoadedStatuses.every(isLoaded => isLoaded);
  },
);
